<h1 mat-dialog-title>
    <mat-icon class="title-icon">person</mat-icon>
    {{'User exercising on the device'|translate}}
</h1>

<div mat-dialog-content class="user-workout-details">
    <div class="device-info">
        <mat-icon>devices</mat-icon>
        <span class="device-label">{{'Device'|translate}}:</span>
        <span class="device-name">{{ deviceName }}</span>
    </div>

    <mat-divider></mat-divider>

    <div class="user-info-section">
        <div class="info-row">
            <mat-icon>person</mat-icon>
            <div class="info-content">
                <span class="info-label">{{'Name'|translate}}:</span>
                <span class="info-value">{{ user.firstName }} {{ user.lastName }}</span>
            </div>
        </div>

        <div class="info-row" *ngIf="user.email">
            <mat-icon>email</mat-icon>
            <div class="info-content">
                <span class="info-label">{{'Email'|translate}}:</span>
                <span class="info-value">{{ user.email }}</span>
            </div>
        </div>

        <div class="info-row" *ngIf="user.phone">
            <mat-icon>phone</mat-icon>
            <div class="info-content">
                <span class="info-label">{{'Phone'|translate}}:</span>
                <span class="info-value">{{ user.phone }}</span>
            </div>
        </div>

        <div class="info-row" *ngIf="user.birthday">
            <mat-icon>cake</mat-icon>
            <div class="info-content">
                <span class="info-label">{{'Birthday'|translate}}:</span>
                <span class="info-value">
                    {{ formatBirthday() }}
                    <span class="age-badge" *ngIf="getAge()">{{ getAge() }} {{'years'|translate}}</span>
                </span>
            </div>
        </div>

        <div class="info-row" *ngIf="user.cardNumber">
            <mat-icon>credit_card</mat-icon>
            <div class="info-content">
                <span class="info-label">{{'Card number'|translate}}:</span>
                <span class="info-value">{{ user.cardNumber }}</span>
            </div>
        </div>
    </div>
</div>

<div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="onNoClick()">
        <mat-icon>close</mat-icon>
        {{'Close'|translate}}
    </button>
    <button mat-raised-button type="button" color="primary" (click)="goToCustomerDetails()">
        <mat-icon>arrow_forward</mat-icon>
        {{'Go to customer details'|translate}}
    </button>
</div>